(function () {
  var mobileQuery = window.matchMedia('(max-width: 767.98px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initToolbarScroll(toolbar) {
    var lastScrollY = window.scrollY;
    var state = 'full';

    function setState(next) {
      if (next === state) return;
      state = next;
      toolbar.setAttribute('data-bar-state', state);
    }

    function onScroll() {
      if (!mobileQuery.matches) {
        setState('full');
        lastScrollY = window.scrollY;
        return;
      }
      var y = window.scrollY;
      var delta = y - lastScrollY;
      lastScrollY = y;

      if (y <= 8) {
        setState('full');
      } else if (delta > 2) {
        setState('hidden');
      } else if (delta < -2) {
        setState('small');
      }
    }

    function documentTop(element) {
      var top = 0;
      var el = element;
      while (el) {
        top += el.offsetTop;
        el = el.offsetParent;
      }
      return top;
    }

    function expand() {
      if (state === 'full') return;
      setState('full');
      var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var top = documentTop(toolbar) - headerHeight;
      window.scrollTo({
        top: Math.max(top, 0),
        behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    toolbar.addEventListener('click', expand);
  }

  document.querySelectorAll('[data-toolbar-sticky]').forEach(initToolbarScroll);
})();
